module.exports = "/_next/static/images/jaraad-608becf4c8e87e1537013fab857d597c.jpeg";